import FoodOrdersListPanel from '../../components/food/FoodOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function MerchantFoodLiveOrdersPage() {
  return (
    <PageShell>
      <PageHeader
        title="Live Food Orders"
        subtitle="Accept incoming restaurant orders, mark ready, and track delivery"
      />
      <FoodOrdersListPanel
        scope="live"
        title="Active food orders"
        queryKeyPrefix="merchant-food-live"
      />
    </PageShell>
  );
}
